import keyBy from 'lodash/keyBy';

import { TFunction } from '@lyearn/i18n';
import { Field, Fields } from '@/components/Form';
import { FieldType } from '@/modules/corporate/modules/database/interfaces';

const adaptCommonFieldProps = (field: FieldType): Field => {
  const { config, viewField } = field;

  return {
    description: viewField.descriptionEnabled ? viewField.description : null,
    label: viewField.label,
    name: viewField.fieldId,
    placeholder: viewField.placeholder!,
    required: viewField.required,
    type: config.Viewer.fieldType,
    // @ts-expect-error Component can be undefined for non custom fields
    Component: config.Component,
  };
};

interface AdaptEditorFormFieldParams {
  isFieldPublished: (fieldId: string) => boolean;
  fields: FieldType[];
  isEditor?: boolean;
  overrides?: object;
  t: TFunction;
}

export const adaptFormEditorFields = (params: AdaptEditorFormFieldParams) => {
  const { isFieldPublished, fields, isEditor, overrides, t } = params;

  const adaptedFields = fields
    .filter((field) => field.viewField.visible)
    .map((field) => {
      const { Editor, Viewer } = field.config;
      return {
        ...adaptCommonFieldProps(field),
        ...(isEditor
          ? Editor.adaptEditorFormField?.({
              allowPartialUpdates: isFieldPublished(field.viewField.fieldId),
              field,
              t,
            })
          : Viewer.adaptFormField?.({ field, t })),
        ...overrides,
      };
    });

  return keyBy(adaptedFields, 'name') as Fields;
};
